import {
  ClientResponse,
  SendConversationTypingParams,
} from '@stripe-internal/conversations-client';

export class SendConversationTypingHandler {
  // eslint-disable-next-line class-methods-use-this
  call = async (
    _params?: SendConversationTypingParams,
  ): Promise<ClientResponse> => {
    return {code: 200};
  };
}
